export var DefaultGdprPreferences = {
    functional: true,
    advertising: false,
    sessionReplay: false,
    dataSale: true,
};
export var AllAllowedPreferences = {
    functional: true,
    advertising: true,
    sessionReplay: true,
    dataSale: true,
};
export var overrides = {
    ie: {
        functional: false,
    },
    pt: {
        functional: false,
    },
    no: {
        functional: false,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnN0YW50cy9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLElBQU0sc0JBQXNCLEdBQWU7SUFDaEQsVUFBVSxFQUFFLElBQUk7SUFDaEIsV0FBVyxFQUFFLEtBQUs7SUFDbEIsYUFBYSxFQUFFLEtBQUs7SUFDcEIsUUFBUSxFQUFFLElBQUk7Q0FDZixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0scUJBQXFCLEdBQWU7SUFDL0MsVUFBVSxFQUFFLElBQUk7SUFDaEIsV0FBVyxFQUFFLElBQUk7SUFDakIsYUFBYSxFQUFFLElBQUk7SUFDbkIsUUFBUSxFQUFFLElBQUk7Q0FDZixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sU0FBUyxHQUFjO0lBQ2xDLEVBQUUsRUFBRTtRQUNGLFVBQVUsRUFBRSxLQUFLO0tBQ2xCO0lBQ0QsRUFBRSxFQUFFO1FBQ0YsVUFBVSxFQUFFLEtBQUs7S0FDbEI7SUFDRCxFQUFFLEVBQUU7UUFDRixVQUFVLEVBQUUsS0FBSztLQUNsQjtDQUNGLENBQUMifQ==